import { useState } from "react";
import {
  Activity,
  BarChart3,
  BookUser,
  Building2,
  FileSpreadsheet,
  Gavel,
  LayoutDashboard,
  LifeBuoy,
  Megaphone,
  ShieldCheckIcon,
  User,
} from "lucide-react";

import { cn } from "@/libs/cn";
import { CaretLeftIcon, CaretRightIcon } from "@/modules/common/assets/icons";
import { BrandLogoCropped } from "@/modules/common/assets/logos";
import { useIsMobile } from "@/modules/common/hooks/useMediaQuery";
import { ROUTES } from "@/routes/constants/routes";

import SidebarGroup from "../SidebarGroup";
import SidebarItem from "../SidebarItem";
import SidebarUser from "../SidebarUser";

const Sidebar = () => {
  const isMobile = useIsMobile();
  const [isExpanded, setIsExpanded] = useState(!isMobile);
  const [wasMobile, setWasMobile] = useState(isMobile);

  if (wasMobile !== isMobile) {
    setWasMobile(isMobile);
    setIsExpanded(!isMobile);
  }

  return (
    <div className="flex flex-col h-screen z-9 shrink-0">
      <aside
        className={cn(
          "flex flex-col bg-brand-secondary flex-1 min-h-0 transition-all duration-300 ease-in-out",
          isExpanded ? "w-70" : "w-20",
        )}
      >
        <div className={cn("relative flex items-center gap-2 p-4", !isExpanded && "justify-center")}>
          <BrandLogoCropped className="bg-white rounded-lg w-8 h-8 shrink-0" />
          {isExpanded && (
            <span className="flex-1 min-w-0 text-white text-[14px] font-bold">
              <p className="truncate">POUPENERGIA</p>
              <p className="text-ui-text-muted text-[12px] font-normal truncate">Painel Administrativo</p>
            </span>
          )}

          <button
            aria-label={isExpanded ? "Recolher menu" : "Expandir menu"}
            className={cn(
              "w-6 h-6 rounded-full bg-brand-primary text-white flex items-center justify-center cursor-pointer shadow-md shrink-0 transition-all duration-200 ease-in-out",
              !isExpanded && "absolute top-5 -right-2",
            )}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? <CaretLeftIcon className="w-4 h-4" /> : <CaretRightIcon className="w-4 h-4" />}
          </button>
        </div>

        <span className="w-full h-px mb-4" />

        <nav className="flex flex-col w-full overflow-y-auto overflow-x-hidden flex-1 min-h-0 sidebar-scroll transition-all duration-300 ease-in-out">
          <div className={isExpanded ? "flex flex-col px-4 gap-1" : "flex-1 flex flex-col px-2 gap-1"}>
            <SidebarItem icon={LayoutDashboard} route={ROUTES.DASHBOARD.HOME} label="Dashboard" isExpanded={isExpanded} />
            <SidebarItem icon={Activity} route={ROUTES.LOGS.LIST} label="Logs / Auditoria" isExpanded={isExpanded} />

            <SidebarGroup label="Cadastro geral" isExpanded={isExpanded}>
              <SidebarItem icon={Building2} route={ROUTES.MANAGER.LIST} label="Gestoras" isExpanded={isExpanded} />
              <SidebarItem icon={ShieldCheckIcon} route={ROUTES.USERS.LIST} label="Usuários Administrativos" isExpanded={isExpanded} />
            </SidebarGroup>

            <SidebarGroup label="Configurações" isExpanded={isExpanded}>
              <SidebarItem icon={FileSpreadsheet} route={ROUTES.ANEEL_TARIFFS.LIST} label="Tarifas ANEEL" isExpanded={isExpanded} />
            </SidebarGroup>

            <SidebarGroup label="Suporte" isExpanded={isExpanded}>
              <SidebarItem icon={LifeBuoy} route={ROUTES.HELP.HOME} label="Central de Ajuda" isExpanded={isExpanded} />
            </SidebarGroup>

            <SidebarGroup label="Gestão Comercial" isExpanded={isExpanded}>
              <SidebarItem icon={BookUser} route={ROUTES.LEADS.LIST} label="Leads" isExpanded={isExpanded} />
            </SidebarGroup>

            <SidebarGroup label="Comunicação" isExpanded={isExpanded}>
              <SidebarItem icon={Megaphone} route={ROUTES.RELEASE_NOTES.LIST} label="Notas de Atualização" isExpanded={isExpanded} />
            </SidebarGroup>

            <SidebarGroup label="Em breve" isExpanded={isExpanded}>
              <SidebarItem icon={User} label="Gestão global de usuários" isExpanded={isExpanded} />
              <SidebarItem icon={Gavel} label="Governança" isExpanded={isExpanded} />
              <SidebarItem icon={BarChart3} label="Relatórios" isExpanded={isExpanded} />
            </SidebarGroup>
          </div>

          <div className="mt-auto border-t-2 border-brand-secondary-contrast/10 transition-all duration-300 ease-in-out">
            <SidebarUser isExpanded={isExpanded} />
          </div>
        </nav>
      </aside>
    </div>
  );
};

export default Sidebar;
